import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { siteConfig } from '../data/site-content';
import { Plus, Minus } from 'lucide-react';

const FAQ = () => {
  const faqCategories = [
    {
      title: "Parterapi & Relationscoaching",
      icon: "fa-regular fa-heart",
      items: [
        {
          question: "Kan jeg komme alene til parterapi?",
          answer: "Ja, det kan du absolut. Mange vælger at starte alene for at få klarhed over deres egne reaktioner, mønstre og ønsker i relationen. At arbejde med sine egne relationelle mønstre kan skabe en stor positiv forandring i parforholdet, selvom din partner ikke deltager."
        },
        {
          question: "Hvad koster parterapi?",
          answer: "Første relationssession koster 375 kr. pr. person (50 minutter) og gælder uanset om du kommer alene eller sammen med din partner. Herefter koster en session 1.950 kr. Du kan også vælge et forløb med 5 sessioner til 9.250 kr. eller 10 sessioner til 17.500 kr. Hvis forløbet efter første session fortsætter individuelt, gælder prisen for individuel terapi: 1.800 kr."
        },
        {
          question: "Hvad sker der i første relationssession?",
          answer: "Første relationssession (375 kr. pr. person, 50 minutter) er en afklarende samtale. Her kortlægger vi jeres eller dine udfordringer, ser på de mønstre, der skaber afstand eller konflikter, og lægger en klar plan for det videre forløb. I får også de første konkrete redskaber med hjem."
        },
        {
          question: "Skal begge parter være med til parterapi?",
          answer: "Nej, det er ikke et krav. Selvom det ofte er mest optimalt at arbejde med dynamikken sammen, kan du sagtens få stort udbytte af relationscoaching eller parterapi alene. Vi fokuserer på de mønstre, du indgår i, og hvordan du kan ændre din egen adfærd og reaktioner."
        },
        {
          question: "Kan parterapi foregå online?",
          answer: "Ja, parterapi og relationscoaching kan sagtens foregå online via et sikkert videolink. Det er lige så effektivt som fysisk fremmøde og kan være en fleksibel løsning i en travl hverdag, eller hvis I befinder jer forskellige steder."
        },
        {
          question: "Er relationscoaching det samme som parterapi?",
          answer: "Relationscoaching og parterapi minder meget om hinanden og overlapper ofte. Parterapi har typisk fokus på at løse dybere konflikter, hele sår og genopbygge tillid i parforholdet, mens relationscoaching i højere grad fokuserer på konkrete kommunikationsredskaber, målsætninger og mønstre i jeres relationer generelt."
        }
      ]
    },
    {
      title: "Behandling & Metoder",
      icon: "fa-regular fa-brain-circuit",
      items: [
        {
          question: "Hvilke teknikker eller metoder anvender du oftest i dine sessioner?",
          answer: "Jeg kombinerer primært metakognitiv terapi og hypnose. Metakognitiv terapi hjælper dig med at ændre din relation til dine tanker, mens hypnose arbejder med det underbevidste for at skabe hurtige og vedvarende forandringer."
        },
        {
          question: "Hvilken uddannelse og erfaring har du, Lars?",
          answer: "Jeg har over 26 års erfaring med at hjælpe mennesker. Jeg er Psykoterapeut MPF, certificeret metakognitiv psykoterapeut fra Neokognitivt Institut, Level IV – højeste niveau, samt certificeret metakognitiv supervisor og hypnoterapeut."
        },
        {
          question: "Hvad kan jeg forvente fra en session hos dig, Lars?",
          answer: "Du kan forvente en tryg, professionel og uformel atmosfære. Vi arbejder målrettet med dine udfordringer, og du får konkrete værktøjer og øvelser med hjem, som du kan bruge med det samme i din hverdag."
        }
      ]
    },
    {
      title: "Priser & Forløb",
      icon: "fa-regular fa-tags",
      items: [
        {
          question: "Hvordan fungerer betaling?",
          answer: "Du kan betale med MobilePay, bankoverførsel eller kontant i klinikken. Betaling sker typisk umiddelbart efter sessionen, medmindre du har købt en forløbspakke på forhånd."
        },
        {
          question: "Tilbyder du rabatter?",
          answer: "Ja, jeg tilbyder en særlig introduktionspris på den første behandlingssession til kun 375 kr. (50 minutters varighed). Derudover er der penge at spare ved at købe en forløbspakke til flere sessioner."
        },
        {
          question: "Hvad er forløbspakker, og hvordan fungerer de?",
          answer: "En forløbspakke giver dig mulighed for at købe 5 eller 10 sessioner forud til en reduceret pris. Det er en god løsning til dig, der ønsker et sammenhængende forløb med fokus på langsigtede resultater."
        },
        {
          question: "Kan jeg dele min forløbspakke med en ven eller et familiemedlem?",
          answer: "Ja, forløbspakken er fleksibel og kan efter aftale deles med nære relationer, hvis I begge har brug for et forløb. Kontakt mig for at høre nærmere om mulighederne."
        },
        {
          question: "Binder jeg mig til et længere forløb, når jeg booker første behandlingssession?",
          answer: "Nej. Første behandlingssession er en enkelt session, hvor vi skaber overblik over det, du ønsker hjælp til. Du behøver ikke beslutte dig for et længere forløb på forhånd."
        },
        {
          question: "Kan jeg starte med én session og først senere vælge klippekort?",
          answer: "Ja. Mange starter med første behandlingssession eller en enkeltsession og vælger først klippekort senere, hvis det giver mening at fortsætte i et mere samlet forløb."
        },
        {
          question: "Hvornår giver et klippekort bedst mening?",
          answer: "Et klippekort kan mening, hvis du ønsker kontinuitet og allerede ved, at du gerne vil arbejde med din problematik over flere sessioner. Det kan især være relevant ved længerevarende stress, angst, tankemylder, søvnproblemer eller tilbagevendende mønstre."
        },
        {
          question: "Kan rabatter kombineres med klippekort?",
          answer: "Som udgangspunkt gælder rabatter på individuelle sessioner, medmindre andet er aftalt. Kontakt mig gerne, hvis du er i tvivl om, hvilken løsning der passer bedst til din situation."
        },
        {
          question: "Hvad sker der, hvis jeg ikke får brugt alle klip på mit klippekort?",
          answer: "Klippekort gælder i 4 måneder fra købsdato. Det er derfor en god idé kun at vælge klippekort, hvis du forventer at kunne bruge sessionerne inden for perioden."
        },
        {
          question: "Kan jeg få en faktura, hvis sessionerne er erhvervsrettede?",
          answer: "Ja. Ved erhvervscoaching kan der udstedes faktura til virksomheden, hvis forløbet aftales som erhvervsrettet coaching. Du skal selv afklare med revisor eller bogholder, om udgiften kan fratrækkes."
        }
      ]
    },
    {
      title: "Praktisk & Booking",
      icon: "fa-regular fa-calendar-days",
      items: [
        {
          question: "Hvordan kan jeg booke en tid?",
          answer: "Du kan nemt booke en tid online via bookingsystemet her på siden. Du er også velkommen til at ringe til mig på 27 20 46 71 eller sende en mail til kontakt@corehypnose.dk."
        },
        {
          question: "Har du ventetid?",
          answer: "Jeg bestræber mig på at tilbyde tider hurtigt, så du kan få hjælp, når du har brug for det. Ofte kan du få en tid inden for en uge eller to. Du kan se de ledige tider direkte i mit bookingsystem."
        },
        {
          question: "Hvad sker der, hvis jeg har brug for at aflyse min tid?",
          answer: "Afbud skal ske senest 24 timer før den planlagte session. Ved senere afbud eller udeblivelse faktureres det fulde beløb for sessionen, da tiden er reserveret til dig."
        },
        {
          question: "Hvordan foregår online sessioner?",
          answer: "Online sessioner foregår via et sikkert videolink (f.eks. Zoom eller Teams). Du modtager et link før sessionen, og det eneste det kræver er en stabil internetforbindelse og et roligt sted, hvor du kan tale uforstyrret."
        },
        {
          question: "Er online-sessioner lige så effektive som personlige møder i klinikken?",
          answer: "Ja, min erfaring og international forskning viser, at online terapi er præcis lige så effektivt som fysiske møder. Det giver dig desuden mulighed for at modtage behandling i trygge rammer derhjemme."
        },
        {
          question: "Kan jeg skifte mellem online sessioner og sessioner i Valby?",
          answer: "Ja. Du kan som udgangspunkt godt skifte mellem online sessioner og sessioner i klinikken i Valby, alt efter hvad der passer bedst for dig."
        },
        {
          question: "Kan jeg bruge sessionerne til både metakognitiv terapi og hypnose?",
          answer: "Ja. En individuel session kan bruges fleksibelt, afhængigt af hvad der er relevant for dig. Nogle sessioner vil have mest fokus på metakognitiv terapi, andre kan inddrage hypnose eller hypnoterapeutiske elementer, hvis det passer til dit forløb."
        },
        {
          question: "Hvordan sikrer du fortrolighed og beskyttelse af mine oplysninger?",
          answer: "Jeg har fuld tavshedspligt og overholder alle regler i GDPR-lovgivningen. Dine oplysninger behandles fortroligt og sikkert, så du kan føle dig helt tryg i forløbet."
        },
        {
          question: "Hvad hvis jeg ikke er tilfreds efter en session?",
          answer: "Din trivsel er det vigtigste for mig. Hvis du mod forventning ikke føler, at sessionen gav dig det ønskede, tager jeg en åben dialog med dig om det, så jeg kan justere forløbet eller finde en løsning, der giver mening for dig."
        }
      ]
    }
  ];

  return (
    <>
      <Helmet>
        <title>FAQ – Ofte stillede spørgsmål – {siteConfig.name}</title>
        <meta name="description" content="Få svar på de mest stillede spørgsmål om metakognitiv terapi, hypnose, parterapi og forløb hos Lars Nissen Corell – Psykoterapeut MPF." />
      </Helmet>

      <section className="py-24 bg-[#FAF7F2]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#8C2F12] font-bold uppercase tracking-[0.2em] mb-4">Alt Du Bør Vide.</h2>
            <h1 className="text-4xl md:text-5xl font-serif text-[#123F13] mb-6 uppercase">OFTE STILLEDE SPØRGSMÅL.</h1>
            <p className="text-lg text-[#3B352F]/70 max-w-2xl mx-auto mb-10">
              Her har jeg samlet svar på de spørgsmål, jeg oftest bliver stillet. Finder du ikke det du søger, er du altid velkommen til at kontakte mig.
            </p>

            {/* Kategori-navigation (Hurtigt overblik) */}
            <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
              {faqCategories.map((category, catIndex) => (
                <button
                  key={catIndex}
                  onClick={() => {
                    const element = document.getElementById(`faq-cat-${catIndex}`);
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                  }}
                  className="flex items-center gap-2.5 px-5 py-3 bg-white border border-[#E8DDCE] rounded-full text-[#123F13] text-sm font-medium hover:border-[#8C2F12] hover:text-[#8C2F12] transition-all shadow-sm hover:shadow-md cursor-pointer group"
                >
                  {category.icon && <i className={`${category.icon} text-[#8C2F12] text-xs transition-transform group-hover:scale-110`} />}
                  <span>{category.title}</span>
                </button>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
            {/* Venstre kolonne: Kategoriserede spørgsmål */}
            <div className="lg:col-span-7 space-y-12">
              {faqCategories.map((category, catIndex) => (
                <div key={catIndex} id={`faq-cat-${catIndex}`} className="space-y-6 scroll-mt-24">
                  <div className="flex items-center gap-3 pb-3 border-b border-[#E8DDCE]">
                    {category.icon && <i className={`${category.icon} text-[#8C2F12] text-lg`} />}
                    <h3 className="text-2xl font-serif text-[#123F13]">{category.title}</h3>
                  </div>
                  <div className="space-y-4">
                    {category.items.map((faq, index) => (
                      <AccordionItem key={index} question={faq.question} answer={faq.answer} />
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* Højre kolonne: Info, billede og kontakt */}
            <div className="lg:col-span-5 space-y-8 lg:sticky lg:top-24">
              <div className="bg-white p-8 rounded-2xl border border-[#E8DDCE] text-center lg:text-left">
                <h3 className="text-2xl font-serif text-[#123F13] mb-3">Slip for angst, stress, og depression.</h3>
                <p className="text-[#3B352F]/70">Med over 26 års erfaring står jeg klar til at hjælpe dig.</p>
              </div>

              <div className="rounded-2xl overflow-hidden shadow-xl border border-[#E8DDCE] bg-white">
                <img 
                  src="https://assets.auxodev.dk/assets/c5965315-775d-45c8-ad9e-70e7ef29846e/0eff3558-e391-446d-a78d-7ecad2ae187e.png" 
                  alt="Ofte stillede spørgsmål - FAQ" 
                  className="w-full h-auto block object-contain"
                />
              </div>

              <div className="bg-white p-8 rounded-2xl border border-[#E8DDCE] space-y-8">
                <div>
                  <h4 className="font-bold text-[#123F13] text-xl mb-4">Kontaktinformation</h4>
                  <div className="space-y-3 text-[#3B352F]/80">
                    <p className="font-bold text-[#123F13] text-lg">Lars Nissen Corell – Psykoterapeut MPF</p>
                    <p className="text-sm text-[#3B352F]/80">Certificeret metakognitiv psykoterapeut (Level IV), supervisor & hypnoterapeut</p>
                    <p>Valby Tingsted 7, 2500 Valby</p>
                    <p>Tlf: <a href="tel:27204671" className="hover:text-[#8C2F12] transition-colors font-medium">27 20 46 71</a></p>
                    <p>Email: <a href="mailto:kontakt@corehypnose.dk" className="hover:text-[#8C2F12] transition-colors font-medium">kontakt@corehypnose.dk</a></p>
                    <p className="text-sm pt-3 border-t border-[#FAF7F2] text-[#3B352F]/60">CVR-nr.: 41913843</p>
                  </div>
                </div>

                <div className="pt-6 border-t border-[#FAF7F2]">
                  <h4 className="font-bold text-[#123F13] text-xl mb-4">Åbningstider</h4>
                  <div className="space-y-3 text-[#3B352F]/80">
                    <div className="flex justify-between py-1 border-b border-[#FAF7F2]">
                      <span>Mandag - Fredag</span>
                      <span className="font-medium text-[#123F13]">9.00 - 16.00</span>
                    </div>
                    <div className="flex justify-between py-1 border-b border-[#FAF7F2]">
                      <span>Lørdag - Søndag</span>
                      <span className="text-[#8C2F12] font-medium">Lukket</span>
                    </div>
                  </div>
                </div>

                <div className="pt-2">
                  <a href="/bestil-tid" className="block w-full text-center bg-[#123F13] text-white py-4 rounded-xl font-bold hover:bg-[#123F13]/90 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5">
                    Book din tid nu
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const AccordionItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="bg-white border border-[#E8DDCE] rounded-xl overflow-hidden transition-all duration-300">
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-6 py-5 text-left flex justify-between items-center hover:bg-[#FAF7F2] transition-colors"
      >
        <span className="font-bold text-[#123F13] md:text-lg pr-8">{question}</span>
        <div className={`shrink-0 text-[#123F13] transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}>
          {isOpen ? <Minus size={20} /> : <Plus size={20} />}
        </div>
      </button>
      <div className={`transition-all duration-300 ease-in-out overflow-hidden ${isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`}>
        <div className="px-6 pb-6 text-[#3B352F]/70 leading-relaxed border-t border-[#FAF7F2] pt-4">
          {answer}
        </div>
      </div>
    </div>
  );
};

export default FAQ;